<template>
	<el-card v-loading="loading" shadow="hover">
		<div class="row row-cols-auto justify-content-between g-1">
			<el-space spacer=":" :size="4">
				<span>Persentase Kelangkapan Data Ayah</span>
				<transition name="slide-up" mode="out-in">
					<div :key="progresData.progres_data_ayah" :class="progresData.progres_data_ayah_class">{{ progresData.progres_data_ayah }}%</div>
				</transition>
			</el-space>
			<div class="col-auto ms-auto" v-if="isPengelola || isWaliKelas || isSiswa">
				<transition name="fade" mode="out-in">
					<el-button
						:key="edit"
						:type="edit ? 'info' : 'primary'"
						:icon="edit ? 'Close' : 'Edit'"
						size="small"
						:disabled="progresData.kunci_data === 1 && !isPengelola"
						plain
						round
						@click="edit = !edit">
						<el-tooltip content="Akses edit data terkunci" :offset="24" v-if="progresData.kunci_data === 1 && !isPengelola">Edit</el-tooltip>
						<span v-else>
							{{ edit ? "Batal Edit" : "Edit" }}
						</span>
					</el-button>
				</transition>
			</div>
		</div>
		<hr />
		<transition name="fade" mode="out-in">
			<template v-if="edit">
				<el-form
					:model="form"
					:rules="rules"
					@submit.prevent="updateData"
					ref="formDataAyah"
					label-width="auto"
					label-position="top"
					require-asterisk-position="right"
					:disabled="loadingForm"
					:scroll-to-error="loadingForm"
					inline-message>
					<el-row :gutter="12">
						<el-divider content-position="left">Identitas Dasar</el-divider>
						<transition name="slide-right" mode="out-in">
							<el-col :xs="24" :sm="8" :md="8" :xl="5" v-if="fieldAvailable.status_ortu_id">
								<el-form-item label="Status" prop="status_ortu_id">
									<el-select v-model="form.status_ortu_id" filterable :placeholder="dataAyah.deskripsi_status || 'Pilih status'" clearable>
										<el-option v-for="so in listStatusOrtu" :key="so.status_ortu_id" :label="so.deskripsi" :value="so.status_ortu_id" />
									</el-select>
								</el-form-item>
							</el-col>
						</transition>
						<transition name="slide-right" mode="out-in">
							<el-col :xs="24" :sm="16" :md="16" :xl="10" v-if="fieldAvailable.nama">
								<el-form-item label="Nama" prop="nama">
									<el-input
										v-model="form.nama"
										:placeholder="dataAyah.nama || 'Nama lengkap ayah'"
										clearable
										:formatter="(val) => val.toUpperCase()"
										:parser="(val) => val.toUpperCase()" />
								</el-form-item>
							</el-col>
						</transition>
						<transition name="slide-right" mode="out-in">
							<el-col :xs="24" :sm="11" :md="10" :xl="6" v-if="fieldAvailable.nik">
								<el-form-item label="NIK" prop="nik">
									<el-input v-model="form.nik" :placeholder="dataAyah.nik || 'Nomor Induk Kependudukan'" clearable />
								</el-form-item>
							</el-col>
						</transition>
						<transition name="slide-right" mode="out-in">
							<el-col :xs="12" :sm="5" :xl="3" v-if="fieldAvailable.tahun_lahir">
								<el-form-item label="Tahun Lahir" prop="tahun_lahir">
									<el-date-picker v-model="form.tahun_lahir" type="year" value-format="YYYY" :placeholder="dataAyah.tahun_lahir || '-'" class="w-100" clearable />
								</el-form-item>
							</el-col>
						</transition>
						<transition name="slide-right" mode="out-in">
							<el-col :xs="12" :sm="5" :xl="3" v-if="fieldAvailable.tahun_wafat">
								<el-form-item label="Tahun Wafat" prop="tahun_wafat">
									<el-date-picker v-model="form.tahun_wafat" type="year" :placeholder="dataAyah.tahun_wafat || '-'" class="w-100" clearable />
								</el-form-item>
							</el-col>
						</transition>
						<transition name="slide-right" mode="out-in">
							<el-col :xs="24" :sm="8" :md="9" :xl="5" v-if="fieldAvailable.kontak">
								<el-form-item label="Kontak" prop="kontak">
									<el-input v-model="form.kontak" :placeholder="dataAyah.kontak || 'Nomor ponsel'" clearable />
								</el-form-item>
							</el-col>
						</transition>
						<transition name="slide-right" mode="out-in">
							<el-col :xs="24" :sm="11" :md="10" :xl="6" v-if="fieldAvailable.berkebutuhan_khusus_id">
								<el-form-item label="Berkebutuhan Khusus" prop="berkebutuhan_khusus_id">
									<el-select v-model="form.berkebutuhan_khusus_id" filterable :placeholder="dataAyah.jenis_kebutuhan_khusus || 'Pilih jika ada'" clearable>
										<el-option v-for="bk in listKebutuhanKhusus" :key="bk.berkebutuhan_khusus_id" :label="bk.jenis" :value="bk.berkebutuhan_khusus_id" />
									</el-select>
								</el-form-item>
							</el-col>
						</transition>

						<transition name="fade" mode="out-in">
							<el-divider content-position="left" v-if="fieldAvailable.pendidikan_id || fieldAvailable.pekerjaan_id || fieldAvailable.penghasilan_id">
								Pendidikan & Pekerjaan
							</el-divider>
						</transition>
						<transition name="slide-right" mode="out-in">
							<el-col :xs="24" :sm="12" :md="8" :xl="6" v-if="fieldAvailable.pendidikan_id">
								<el-form-item label="Pendidikan Terakhir" prop="pendidikan_id">
									<el-select v-model="form.pendidikan_id" filterable :placeholder="dataAyah.jenjang_pendidikan || 'Pilih jenjang pendidikan terakhir'" clearable>
										<el-option v-for="p in listPendidikan" :key="p.pendidikan_id" :label="p.jenjang" :value="p.pendidikan_id" />
									</el-select>
								</el-form-item>
							</el-col>
						</transition>
						<transition name="slide-right" mode="out-in">
							<el-col :xs="24" :sm="12" :md="8" :xl="6" v-if="fieldAvailable.pekerjaan_id">
								<el-form-item label="Pekerjaan" prop="pekerjaan_id">
									<el-select v-model="form.pekerjaan_id" filterable :placeholder="dataAyah.nama_pekerjaan || 'Pilih nama pekerjaan'" clearable>
										<el-option v-for="p in listPekerjaan" :key="p.pekerjaan_id" :label="p.nama" :value="p.pekerjaan_id" />
									</el-select>
								</el-form-item>
							</el-col>
						</transition>
						<transition name="slide-right" mode="out-in">
							<el-col :xs="24" :sm="12" :md="8" :xl="6" v-if="fieldAvailable.penghasilan_id">
								<el-form-item label="Rentang Penghasilan" prop="penghasilan_id">
									<el-select v-model="form.penghasilan_id" filterable :placeholder="dataAyah.rentang_penghasilan || 'Pilih rentang penghasilan'" clearable>
										<el-option v-for="p in listPenghasilan" :key="p.penghasilan_id" :label="p.rentang" :value="p.penghasilan_id" />
									</el-select>
								</el-form-item>
							</el-col>
						</transition>

						<transition name="fade" mode="out-in">
							<el-divider content-position="left" v-if="fieldAvailable.alamat_sama"> Alamat </el-divider>
						</transition>
						<transition name="slide-right" mode="out-in">
							<el-col :span="24" v-if="fieldAvailable.alamat_sama">
								<el-form-item label="Sama dengan siswa?" prop="alamat_sama">
									<el-radio-group v-model="form.alamat_sama">
										<el-radio :value="1">
											Ya
											<em class="text-body-tertiary" v-if="dataAyah.alamat_sama === 1">(data awal)</em>
										</el-radio>
										<el-radio :value="0">
											Tidak
											<em class="text-body-tertiary" v-if="dataAyah.alamat_sama === 0">(data awal)</em>
										</el-radio>
									</el-radio-group>
								</el-form-item>
							</el-col>
						</transition>
						<transition name="slide-right" mode="out-in">
							<el-col :xs="24" :sm="14" :md="10" :xl="8" v-if="fieldAvailable.alamat">
								<el-form-item label="Alamat" prop="alamat">
									<el-input v-model="form.alamat" type="textarea" :rows="2" :placeholder="dataAyah.alamat || 'Alamat pelengkap: nama jalan, dusun, dsb.'" clearable />
								</el-form-item>
							</el-col>
						</transition>
						<transition name="slide-right" mode="out-in">
							<el-col :xs="12" :sm="5" :md="3" :xl="2" v-if="fieldAvailable.rt">
								<el-form-item label="RT" prop="rt">
									<el-input v-model="form.rt" type="number" :placeholder="dataAyah.rt || '-'" clearable />
								</el-form-item>
							</el-col>
						</transition>
						<transition name="slide-right" mode="out-in">
							<el-col :xs="12" :sm="5" :md="3" :xl="2" v-if="fieldAvailable.rw">
								<el-form-item label="RW" prop="rw">
									<el-input v-model="form.rw" type="number" :placeholder="dataAyah.rw || '-'" clearable />
								</el-form-item>
							</el-col>
						</transition>
						<transition name="slide-right" mode="out-in">
							<el-col :xs="24" :sm="12" :md="8" :xl="6" v-if="fieldAvailable.provinsi">
								<el-form-item label="Provinsi" prop="provinsi">
									<el-select v-model="form.provinsi" filterable :placeholder="alamatAwal.nama_prov || 'Pilih provinsi'" clearable>
										<el-option v-for="prov in listProvinsi" :key="prov.wilayah_id" :label="prov.nama" :value="prov.wilayah_id" />
									</el-select>
								</el-form-item>
							</el-col>
						</transition>
						<transition name="slide-right" mode="out-in">
							<el-col :xs="24" :sm="12" :md="8" :xl="6" v-if="fieldAvailable.kabupaten_kota">
								<el-form-item label="Kabupaten/Kota" prop="kabupaten_kota">
									<el-select v-model="form.kabupaten_kota" filterable :placeholder="alamatAwal.nama_kab_kota || 'Pilih kabupaten/kota'" clearable>
										<el-option v-for="kk in listKabKota" :key="kk.wilayah_id" :label="kk.nama" :value="kk.wilayah_id" />
									</el-select>
								</el-form-item>
							</el-col>
						</transition>
						<transition name="slide-right" mode="out-in">
							<el-col :xs="24" :sm="12" :md="8" :xl="6" v-if="fieldAvailable.kecamatan">
								<el-form-item label="Kecamatan" prop="kecamatan">
									<el-select v-model="form.kecamatan" filterable :placeholder="alamatAwal.nama_kec || 'Pilih kecamatan'" clearable>
										<el-option v-for="kec in listKecamatan" :key="kec.wilayah_id" :label="kec.nama" :value="kec.wilayah_id" />
									</el-select>
								</el-form-item>
							</el-col>
						</transition>
						<transition name="slide-right" mode="out-in">
							<el-col :xs="24" :sm="12" :md="8" :xl="6" v-if="fieldAvailable.desa">
								<el-form-item label="Desa" prop="desa">
									<el-select v-model="form.desa" filterable :placeholder="alamatAwal.nama_desa || 'Pilih desa'" clearable>
										<el-option v-for="ds in listDesa" :key="ds.wilayah_id" :label="ds.nama" :value="ds.wilayah_id" />
									</el-select>
								</el-form-item>
							</el-col>
						</transition>

						<transition name="fade" mode="out-in">
							<el-divider content-position="left" v-if="fieldAvailable.foto_ktp">Berkas Pendukung</el-divider>
						</transition>
						<transition name="slide-right" mode="out-in">
							<el-col :xs="24" :md="12" v-if="fieldAvailable.foto_ktp">
								<el-form-item label="Foto KTP" prop="foto_ktp">
									<el-space alignment="start" direction="vertical">
										<el-space wrap>
											<el-upload action="" :auto-upload="false" :show-file-list="false" :on-change="handleFotoKTPChange" accept="image/*">
												<template #trigger>
													<transition name="fade" mode="out-in">
														<el-button v-if="dataAyah.foto_ktp || form.foto_ktp" icon="Refresh" type="primary" plain>Ubah gambar</el-button>
														<el-button v-else icon="Camera" type="info">Pilih gambar</el-button>
													</transition>
												</template>
											</el-upload>
											<transition name="fade" mode="out-in">
												<el-button v-if="form.foto_ktp" icon="Delete" type="danger" plain @click="handleFotoKTPChange(null)"> Hapus </el-button>
											</transition>
										</el-space>
										<el-space wrap :spacer="form.foto_ktp ? switchSpacer : ''">
											<el-image
												v-if="dataAyah.foto_ktp"
												style="width: 150px; height: auto"
												:src="dataAyah.previewFotoKTP"
												:preview-src-list="[dataAyah.previewFotoKTP]"
												show-progress
												fit="cover"
												lazy
												class="shadow bg-white border">
												<template #error>
													<el-space direction="vertical" :size="2" class="w-100 py-4 text-secondary">
														<el-icon class="fs-2"><Picture /></el-icon>
														<em class="small">Gagal dimuat</em>
													</el-space>
												</template>
											</el-image>
											<transition name="slide-up" mode="out-in">
												<el-image
													v-if="form.foto_ktp"
													:key="form.foto_ktp"
													style="width: 150px; height: auto"
													:src="form.previewFotoKTP"
													:preview-src-list="[form.previewFotoKTP]"
													show-progress
													fit="cover"
													lazy
													class="shadow bg-white border">
													<template #error>
														<el-space direction="vertical" :size="2" class="w-100 py-4 text-secondary">
															<el-icon class="fs-2"><Picture /></el-icon>
															<em class="small">Gagal dimuat</em>
														</el-space>
													</template>
												</el-image>
											</transition>
										</el-space>
									</el-space>
								</el-form-item>
							</el-col>
						</transition>

						<transition name="fade" mode="out-in">
							<el-divider content-position="left" v-if="fieldAvailable.catatan">Catatan</el-divider>
						</transition>
						<transition name="slide-right" mode="out-in">
							<el-col :xs="24" :lg="16" :xl="12" v-if="fieldAvailable.catatan">
								<el-form-item label="" prop="catatan">
									<el-input v-model="form.catatan" type="textarea" :rows="2" :placeholder="dataAyah.catatan || 'Catatan (opsional)'" clearable />
								</el-form-item>
							</el-col>
						</transition>

						<el-divider />
						<el-form-item class="ms-auto">
							<el-button type="info" plain @click="edit = false">Batal</el-button>
							<el-button type="success" native-type="submit" :loading="loadingForm">Simpan</el-button>
						</el-form-item>
					</el-row>
				</el-form>
			</template>
			<div v-else>
				<el-descriptions direction="vertical" border :column="24" size="small">
					<template v-for="d in descriptions" :key="d">
						<el-descriptions-item v-if="fieldAvailable[d.key_check]" :label="d.label" :span="d.colspan[breakpoint]" :rowspan="d.rowspan[breakpoint]">
							<template v-if="d.key_val">
								<transition name="slide-up" mode="out-in">
									<div v-if="dataAyah[d.key_check] || typeof dataAyah[d.key_check] === 'number'" :key="dataAyah[d.key_val]">
										<a v-if="d.type === 'link'" :href="dataAyah[d.key_val]" target="_blank" rel="noopener noreferrer">{{ dataAyah[d.key_val] }}</a>
										<el-image
											v-else-if="d.type === 'image'"
											style="width: 150px; height: auto"
											:src="dataAyah[d.key_val]"
											:preview-src-list="[dataAyah[d.key_val]]"
											show-progress
											fit="cover"
											lazy
											class="shadow bg-white border">
											<template #error>
												<el-space direction="vertical" :size="2" class="w-100 py-4 text-secondary">
													<el-icon class="fs-2"><Picture /></el-icon>
													<em class="small">Gagal dimuat</em>
												</el-space>
											</template>
										</el-image>
										<span v-else>{{ d.prefix }}{{ dataAyah[d.key_val] }}{{ d.suffix }}</span>
									</div>
									<div v-else :class="d.fallbackClass || 'text-secondary fst-italic'">{{ d.fallback }}</div>
								</transition>
							</template>
							<template v-else-if="d.key_check === 'alamat_sama'">
								<transition name="slide-up" mode="out-in">
									<div v-if="typeof dataAyah[d.key_check] === 'number'">
										<template v-if="dataAyah[d.key_check] === 0">
											<span v-for="c in d.custom" :key="c">
												<transition name="slide-up" mode="out-in">
													<span v-if="dataAyah[c.key_check]" :key="dataAyah[c.key_val]">{{ c.prefix }}{{ dataAyah[c.key_val] }}{{ c.suffix }}</span>
													<span v-else :class="c.fallbackClass || 'text-secondary fst-italic'">{{ c.fallback }}</span>
												</transition>
											</span>
										</template>
										<template v-else>
											<span v-for="c in d.custom" :key="c">
												<transition name="slide-up" mode="out-in">
													<span v-if="alamatSiswa[c.key_check]" :key="alamatSiswa[c.key_val]">{{ c.prefix }}{{ alamatSiswa[c.key_val] }}{{ c.suffix }}</span>
													<span v-else :class="c.fallbackClass || 'text-secondary fst-italic'">{{ c.fallback }}</span>
												</transition>
											</span>
										</template>
									</div>
									<div v-else :class="d.fallbackClass || 'text-secondary fst-italic'">{{ d.fallback }}</div>
								</transition>
							</template>
							<template v-else>
								<span v-for="c in d.custom" :key="c">
									<transition name="slide-up" mode="out-in">
										<span v-if="dataAyah[c.key_check]" :key="dataAyah[c.key_val]">{{ c.prefix }}{{ dataAyah[c.key_val] }}{{ c.suffix }}</span>
										<span v-else :class="c.fallbackClass || 'text-secondary fst-italic'">{{ c.fallback }}</span>
									</transition>
								</span>
							</template>
						</el-descriptions-item>
					</template>
				</el-descriptions>
			</div>
		</transition>
	</el-card>
</template>

<script>
import { ElDivider } from "element-plus";
import { h } from "vue";
export default {
	name: "DataAyah",
	data() {
		return {
			spacer: h(ElDivider, { direction: "vertical" }),
			switchSpacer: h("i", { class: "bi bi-arrow-left-right" }),
			edit: false,
			loadingForm: false,
			originalForm: null,
			originalFieldAvailable: null,
			alamatAwal: {
				nama_desa: null,
				nama_kec: null,
				nama_kab_kota: null,
				nama_prov: null,
			},
			form: {
				status_ortu_id: null,
				nama: null,
				nik: null,
				tahun_lahir: null,
				tahun_wafat: null,
				berkebutuhan_khusus_id: null,
				pendidikan_id: null,
				pekerjaan_id: null,
				penghasilan_id: null,
				kontak: null,
				alamat_sama: null,
				alamat: null,
				rt: null,
				rw: null,
				desa: null,
				kecamatan: null,
				kabupaten_kota: null,
				provinsi: null,
				catatan: null,
				foto_ktp: null,
				previewFotoKTP: "",
			},
			rules: {
				nik: [
					{ required: false, message: "", trigger: "change" },
					{ pattern: /^[0-9]{16}$/, message: "Nomor Induk Kependudukan terdiri dari 16 digit angka", trigger: "blur" },
				],
				kontak: [
					{ required: false, message: "", trigger: "change" },
					{ pattern: /^[0-9]{9,13}$/, message: "Kontak terdiri dari 9-13 digit angka tanpa spasi atau karakter lain", trigger: "blur" },
				],
				rt: [
					{ required: false, message: "", trigger: "change" },
					{
						validator: this.numberValidator,
						trigger: "blur",
					},
				],
				rw: [
					{ required: false, message: "", trigger: "change" },
					{
						validator: this.numberValidator,
						trigger: "blur",
					},
				],
				kabupaten_kota: [],
				kecamatan: [],
				desa: [],
			},
			fieldAvailable: {
				status_ortu_id: true,
				nama: false,
				nik: false,
				tahun_lahir: false,
				tahun_wafat: false,
				berkebutuhan_khusus_id: false,
				pendidikan_id: false,
				pekerjaan_id: false,
				penghasilan_id: false,
				kontak: false,
				alamat_sama: false,
				alamat: false,
				rt: false,
				rw: false,
				desa: false,
				kecamatan: false,
				kabupaten_kota: false,
				provinsi: false,
				catatan: false,
				foto_ktp: false,
				previewFotoKTP: false,
				updated_at: false,
			},
			listDesaAwal: [],
			listDesa: [],
			listKecamatanAwal: [],
			listKecamatan: [],
			listKabKotaAwal: [],
			listKabKota: [],
			descriptions: [
				{
					label: "Status Ayah",
					type: "text",
					key_check: "status_ortu_id",
					key_val: "deskripsi_status",
					prefix: "",
					suffix: "",
					fallback: "belum diisi",
					fallbackClass: "",
					custom: [],
					colspan: { xs: 24, sm: 8, md: 6, lg: 6, xl: 4 },
					rowspan: { xs: 1, sm: 1, md: 1, lg: 1, xl: 1 },
				},
				{
					label: "Nama Lengkap Ayah",
					type: "text",
					key_check: "nama",
					key_val: "nama",
					prefix: "",
					suffix: "",
					fallback: "belum diisi",
					fallbackClass: "",
					custom: [],
					colspan: { xs: 24, sm: 16, md: 8, lg: 6, xl: 6 },
					rowspan: { xs: 1, sm: 1, md: 1, lg: 1, xl: 1 },
				},
				{
					label: "Nomor Induk Kependudukan",
					type: "text",
					key_check: "nik",
					key_val: "nik",
					prefix: "",
					suffix: "",
					fallback: "belum diisi",
					fallbackClass: "",
					custom: [],
					colspan: { xs: 24, sm: 8, md: 6, lg: 6, xl: 4 },
					rowspan: { xs: 1, sm: 1, md: 1, lg: 1, xl: 1 },
				},
				{
					label: "Tahun Lahir",
					type: "text",
					key_check: "tahun_lahir",
					key_val: "tahun_lahir",
					prefix: "",
					suffix: "",
					fallback: "belum diisi",
					fallbackClass: "",
					custom: [],
					colspan: { xs: 24, sm: 6, md: 4, lg: 6, xl: 2 },
					rowspan: { xs: 1, sm: 1, md: 1, lg: 1, xl: 1 },
				},
				{
					label: "Tahun Wafat",
					type: "text",
					key_check: "tahun_wafat",
					key_val: "tahun_wafat",
					prefix: "",
					suffix: "",
					fallback: "belum diisi",
					fallbackClass: "",
					custom: [],
					colspan: { xs: 24, sm: 6, md: 4, lg: 6, xl: 2 },
					rowspan: { xs: 1, sm: 1, md: 1, lg: 1, xl: 1 },
				},
				{
					label: "Pendidikan Terakhir",
					type: "text",
					key_check: "pendidikan_id",
					key_val: "jenjang_pendidikan",
					prefix: "",
					suffix: "",
					fallback: "belum diisi",
					fallbackClass: "",
					custom: [],
					colspan: { xs: 24, sm: 10, md: 8, lg: 6, xl: 4 },
					rowspan: { xs: 1, sm: 1, md: 1, lg: 1, xl: 1 },
				},
				{
					label: "Pekerjaan",
					type: "text",
					key_check: "pekerjaan_id",
					key_val: "nama_pekerjaan",
					prefix: "",
					suffix: "",
					fallback: "belum diisi",
					fallbackClass: "",
					custom: [],
					colspan: { xs: 24, sm: 14, md: 6, lg: 6, xl: 4 },
					rowspan: { xs: 1, sm: 1, md: 1, lg: 1, xl: 1 },
				},
				{
					label: "Rentang Penghasilan",
					type: "text",
					key_check: "penghasilan_id",
					key_val: "rentang_penghasilan",
					prefix: "",
					suffix: "",
					fallback: "belum diisi",
					fallbackClass: "",
					custom: [],
					colspan: { xs: 24, sm: 10, md: 6, lg: 6, xl: 4 },
					rowspan: { xs: 1, sm: 1, md: 1, lg: 1, xl: 1 },
				},
				{
					label: "Jenis Kebutuhan Khusus",
					type: "text",
					key_check: "berkebutuhan_khusus_id",
					key_val: "jenis_kebutuhan_khusus",
					prefix: "",
					suffix: "",
					fallback: "Tidak ada",
					fallbackClass: "fst-normal",
					custom: [],
					colspan: { xs: 24, sm: 14, md: 4, lg: 6, xl: 4 },
					rowspan: { xs: 1, sm: 1, md: 1, lg: 1, xl: 1 },
				},
				{
					label: "Kontak (No. HP)",
					type: "text",
					key_check: "kontak",
					key_val: "kontak",
					prefix: "",
					suffix: "",
					fallback: "belum diisi",
					fallbackClass: "",
					custom: [],
					colspan: { xs: 24, sm: 10, md: 8, lg: 8, xl: 4 },
					rowspan: { xs: 1, sm: 1, md: 1, lg: 1, xl: 1 },
				},
				{
					label: "Alamat",
					type: "text",
					key_check: "alamat_sama",
					key_val: null,
					prefix: "",
					suffix: "",
					fallback: "belum diisi",
					fallbackClass: "",
					custom: [
						{
							key_check: "alamat",
							key_val: "alamat",
							prefix: "",
							suffix: "",
							fallback: "[alamat pelengkap belum diisi]",
						},
						{
							key_check: "rt",
							key_val: "rt",
							prefix: " RT ",
							suffix: "",
							fallback: " [rt belum diisi]",
						},
						{
							key_check: "rw",
							key_val: "rw",
							prefix: "/RW ",
							suffix: ", ",
							fallback: "/[rw belum diisi], ",
						},
						{
							key_check: "desa",
							key_val: "nama_desa",
							prefix: "Desa ",
							suffix: ", ",
							fallback: "[desa belum diisi], ",
						},
						{
							key_check: "kecamatan",
							key_val: "nama_kec",
							prefix: "",
							suffix: ", ",
							fallback: "[kecamatan belum diisi], ",
						},
						{
							key_check: "kabupaten_kota",
							key_val: "nama_kab_kota",
							prefix: "",
							suffix: ", ",
							fallback: "[kab/kota belum diisi], ",
						},
						{
							key_check: "provinsi",
							key_val: "nama_prov",
							prefix: "",
							suffix: "",
							fallback: "[provinsi belum diisi]",
						},
					],
					colspan: { xs: 24, sm: 24, md: 16, lg: 16, xl: 12 },
					rowspan: { xs: 1, sm: 1, md: 1, lg: 1, xl: 1 },
				},
				{
					label: "Foto KTP Ayah",
					type: "image",
					key_check: "foto_ktp",
					key_val: "previewFotoKTP",
					prefix: "",
					suffix: "",
					fallback: "belum diisi",
					fallbackClass: "",
					custom: [],
					colspan: { xs: 24, sm: 8, md: 8, lg: 6, xl: 8 },
					rowspan: { xs: 1, sm: 1, md: 1, lg: 1, xl: 1 },
				},
				{
					label: "Catatan",
					type: "text",
					key_check: "catatan",
					key_val: "catatan",
					prefix: "",
					suffix: "",
					fallback: "Tidak ada",
					fallbackClass: "fst-normal",
					custom: [],
					colspan: { xs: 24, sm: 16, md: 8, lg: 6, xl: 4 },
					rowspan: { xs: 1, sm: 1, md: 1, lg: 1, xl: 1 },
				},
				{
					label: "Terakhir diperbarui",
					type: "text",
					key_check: "updated_at",
					key_val: "updated_at_styled",
					prefix: "",
					suffix: "",
					fallback: "belum ada perubahan",
					fallbackClass: "",
					custom: [],
					colspan: { xs: 24, sm: 8, md: 8, lg: 6, xl: 4 },
					rowspan: { xs: 1, sm: 1, md: 1, lg: 1, xl: 1 },
				},
			],
		};
	},
	props: {
		progresData: Object,
		dataRinciSiswa: Object,
		loadingData: Object,
		formOptions: Object,
		fieldsStatusOrtu: Object,
		refreshDataParent: Function,
		refreshFormOption: Function,
		updateEditing: Function,
		siswaId: Number,
		isPengelola: Boolean,
		isWaliKelas: Boolean,
		isSiswa: Boolean,
		breakpoint: String,
	},
	computed: {
		alamatSiswa() {
			const detailSiswa = this.dataRinciSiswa["detailSiswa"] || {};
			return {
				alamat: detailSiswa.alamat,
				rt: detailSiswa.rt,
				rw: detailSiswa.rw,
				desa: detailSiswa.desa,
				kecamatan: detailSiswa.kecamatan,
				kabupaten_kota: detailSiswa.kabupaten_kota,
				provinsi: detailSiswa.provinsi,
				nama_desa: detailSiswa.nama_desa,
				nama_kec: detailSiswa.nama_kec,
				nama_kab_kota: detailSiswa.nama_kab_kota,
				nama_prov: detailSiswa.nama_prov,
			};
		},
		alamatSama() {
			if (typeof this.form.alamat_sama === "number") return this.form.alamat_sama;
			if (typeof this.dataAyah.alamat_sama === "number") return this.dataAyah.alamat_sama;
			return null;
		},
		statusOrtuId() {
			if (typeof this.form.status_ortu_id === "number") return this.form.status_ortu_id;
			if (typeof this.dataAyah.status_ortu_id === "number") return this.dataAyah.status_ortu_id;
			return null;
		},
		dataAyah() {
			return this.dataRinciSiswa["dataAyah"] || {};
		},
		listKebutuhanKhusus() {
			return this.formOptions["listKebutuhanKhusus"];
		},
		listProvinsi() {
			return this.formOptions["listProvinsi"];
		},
		listPekerjaan() {
			return this.formOptions["listPekerjaan"];
		},
		listPendidikan() {
			return this.formOptions["listPendidikan"];
		},
		listPenghasilan() {
			return this.formOptions["listPenghasilan"];
		},
		listStatusOrtu() {
			return this.formOptions["listStatusOrtu"];
		},
		loading() {
			return this.loadingData["dataAyah"];
		},
		formChanged() {
			return this.originalForm !== JSON.stringify(this.form);
		},
	},
	watch: {
		"progresData.kunci_data"(val) {
			if (val && this.edit && !this.isPengelola) {
				this.$alert("Akses edit data ditutup oleh petugas. Silakan hubungi petugas untuk membuka akses edit.", "Peringatan", {
					confirmButtonText: "Baik",
				});
				this.edit = false;
			}
		},
		dataAyah: {
			immediate: true,
			handler(val) {
				if (val.status_ortu_id) {
					const statusOrtu = this.fieldsStatusOrtu.find((s) => s.status_ortu_id === val.status_ortu_id);
					if (statusOrtu) {
						const fields = statusOrtu.fields || [];

						fields.forEach((f) => {
							this.fieldAvailable[f.col] = f.is_required;
						});
						if (this.fieldAvailable.alamat_sama) {
							this.fieldAvailable.alamat = this.alamatSama === 0;
							this.fieldAvailable.rt = this.alamatSama === 0;
							this.fieldAvailable.rw = this.alamatSama === 0;
							this.fieldAvailable.desa = this.alamatSama === 0;
							this.fieldAvailable.kecamatan = this.alamatSama === 0;
							this.fieldAvailable.kabupaten_kota = this.alamatSama === 0;
							this.fieldAvailable.provinsi = this.alamatSama === 0;
						}

						this.fieldAvailable.berkebutuhan_khusus_id = this.fieldAvailable.tahun_wafat === false;
						this.fieldAvailable.previewFotoKTP = !!this.fieldAvailable.foto_ktp;
						this.fieldAvailable.catatan = true;
						this.fieldAvailable.updated_at = true;
					}
				}
				if (val.alamat_sama) {
					this.refreshDataParent("detailSiswa");
				}
				if (val.provinsi) {
					this.getListKabKota(val.provinsi, true);
				}
				if (val.kabupaten_kota) {
					this.getListKecamatan(val.kabupaten_kota, true);
				}
				if (val.kecamatan) {
					this.getListDesa(val.kecamatan, true);
				}
			},
		},
		statusOrtuId(val) {
			if (val) {
				const statusOrtu = this.fieldsStatusOrtu.find((s) => s.status_ortu_id === val);
				if (statusOrtu) {
					const fields = statusOrtu.fields || [];

					fields.forEach((f) => {
						this.fieldAvailable[f.col] = f.is_required;
					});
					if (this.fieldAvailable.alamat_sama) {
						this.fieldAvailable.alamat = this.alamatSama === 0;
						this.fieldAvailable.rt = this.alamatSama === 0;
						this.fieldAvailable.rw = this.alamatSama === 0;
						this.fieldAvailable.desa = this.alamatSama === 0;
						this.fieldAvailable.kecamatan = this.alamatSama === 0;
						this.fieldAvailable.kabupaten_kota = this.alamatSama === 0;
						this.fieldAvailable.provinsi = this.alamatSama === 0;
					}

					this.fieldAvailable.berkebutuhan_khusus_id = this.fieldAvailable.tahun_wafat === false;
					this.fieldAvailable.previewFotoKTP = !!this.fieldAvailable.foto_ktp;
					this.fieldAvailable.catatan = true;
					this.fieldAvailable.updated_at = true;
				}
			} else {
				this.fieldAvailable = JSON.parse(this.originalFieldAvailable);
			}
		},
		alamatSama(val) {
			this.fieldAvailable.alamat = val === 0;
			this.fieldAvailable.rt = val === 0;
			this.fieldAvailable.rw = val === 0;
			this.fieldAvailable.desa = val === 0;
			this.fieldAvailable.kecamatan = val === 0;
			this.fieldAvailable.kabupaten_kota = val === 0;
			this.fieldAvailable.provinsi = val === 0;
		},
		"form.provinsi"(val, oldVal) {
			const provChanged = val && val !== this.dataAyah.provinsi;
			if (provChanged) {
				if (this.dataAyah.kabupaten_kota) {
					this.alamatAwal.nama_kab_kota = null;
					this.rules.kabupaten_kota = [{ required: true, message: "Kabupaten/kota harus diisi", trigger: "change" }];
				}
				if (this.dataAyah.kecamatan) {
					this.alamatAwal.nama_kec = null;
					this.rules.kecamatan = [{ required: true, message: "Kecamatan harus diisi", trigger: "change" }];
				}
				if (this.dataAyah.desa) {
					this.alamatAwal.nama_desa = null;
					this.rules.desa = [{ required: true, message: "Desa harus diisi", trigger: "change" }];
				}

				this.form.kabupaten_kota = null;
				this.form.kecamatan = null;
				this.form.desa = null;

				this.getListKabKota(val);
				this.listKecamatan = [];
				this.listDesa = [];
			} else {
				if (oldVal && oldVal !== this.dataAyah.provinsi) this.form.kabupaten_kota = null;

				this.listKabKota = this.listKabKotaAwal;
				this.alamatAwal.nama_kab_kota = this.dataAyah.nama_kab_kota;
				this.rules.kabupaten_kota = [];

				const kabChanged = this.form.kabupaten_kota && this.form.kabupaten_kota !== this.dataAyah.kabupaten_kota;
				const kecChanged = this.form.kecamatan && this.form.kecamatan !== this.dataAyah.kecamatan;

				if (kabChanged && this.dataAyah.kecamatan) {
					this.alamatAwal.nama_kec = null;
					this.rules.kecamatan = [{ required: true, message: "Kecamatan harus diisi", trigger: "change" }];
				} else {
					this.listKecamatan = this.listKecamatanAwal;
					this.alamatAwal.nama_kec = this.dataAyah.nama_kec;
					this.rules.kecamatan = [];
				}
				if ((kabChanged || kecChanged) && this.dataAyah.desa) {
					this.alamatAwal.nama_desa = null;
					this.rules.desa = [{ required: true, message: "Desa harus diisi", trigger: "change" }];
				} else {
					this.listDesa = this.listDesaAwal;
					this.alamatAwal.nama_desa = this.dataAyah.nama_desa;
					this.rules.desa = [];
				}
			}
		},
		"form.kabupaten_kota"(val, oldVal) {
			const provChanged = this.form.provinsi && this.form.provinsi !== this.dataAyah.provinsi;
			const kabChanged = val && val !== this.dataAyah.kabupaten_kota;
			if (kabChanged || provChanged) {
				if (this.dataAyah.kecamatan) {
					this.alamatAwal.nama_kec = null;
					this.rules.kecamatan = [{ required: true, message: "Kecamatan harus diisi", trigger: "change" }];
				}
				if (this.dataAyah.desa) {
					this.alamatAwal.nama_desa = null;
					this.rules.desa = [{ required: true, message: "Desa harus diisi", trigger: "change" }];
				}

				this.form.kecamatan = null;
				this.form.desa = null;

				if (kabChanged) this.getListKecamatan(val);
				else this.listKecamatan = [];

				this.listDesa = [];
			} else {
				if (oldVal && oldVal !== this.dataAyah.kabupaten_kota) this.form.kecamatan = null;

				this.listKecamatan = this.listKecamatanAwal;
				this.alamatAwal.nama_kec = this.dataAyah.nama_kec;
				this.rules.kecamatan = [];

				const kecChanged = this.form.kecamatan && this.form.kecamatan !== this.dataAyah.kecamatan;
				if (kecChanged && this.dataAyah.desa) {
					this.alamatAwal.nama_desa = null;
					this.rules.desa = [{ required: true, message: "Desa harus diisi", trigger: "change" }];
				} else {
					this.listDesa = this.listDesaAwal;
					this.alamatAwal.nama_desa = this.dataAyah.nama_desa;
					this.rules.desa = [];
				}
			}
		},
		"form.kecamatan"(val, oldVal) {
			const provChanged = this.form.provinsi && this.form.provinsi !== this.dataAyah.provinsi;
			const kabChanged = this.form.kabupaten_kota && this.form.kabupaten_kota !== this.dataAyah.kabupaten_kota;
			const kecChanged = val && val !== this.dataAyah.kecamatan;
			if (kecChanged || kabChanged || provChanged) {
				if (this.dataAyah.desa) {
					this.alamatAwal.nama_desa = null;
					this.rules.desa = [{ required: true, message: "Desa harus diisi", trigger: "change" }];
				}

				this.form.desa = null;
				if (kecChanged) this.getListDesa(val);
				else this.listDesa = [];
			} else {
				if (oldVal && oldVal !== this.dataAyah.kecamatan) this.form.desa = null;

				this.listDesa = this.listDesaAwal;
				this.alamatAwal.nama_desa = this.dataAyah.nama_desa;
				this.rules.desa = [];
			}
		},
		edit(val) {
			if (val) {
				this.alamatAwal = {
					nama_desa: this.dataAyah.nama_desa,
					nama_kec: this.dataAyah.nama_kec,
					nama_kab_kota: this.dataAyah.nama_kab_kota,
					nama_prov: this.dataAyah.nama_prov,
				};
			} else {
				this.$refs.formDataAyah.resetFields();
				this.form.previewFotoKTP = "";
			}
		},
		formChanged(val) {
			this.updateEditing(val);
		},
	},
	mounted() {
		this.originalForm = JSON.stringify(this.form);
		this.originalFieldAvailable = JSON.stringify(this.fieldAvailable);
		this.refreshFormOption("listKebutuhanKhusus");
		this.refreshFormOption("listProvinsi");
		this.refreshFormOption("listPekerjaan");
		this.refreshFormOption("listPendidikan");
		this.refreshFormOption("listPenghasilan");
		this.refreshFormOption("listStatusOrtu");
	},
	beforeUnmount() {},
	beforeRouteLeave(to, from, next) {
		if (this.formChanged) {
			const answer = window.confirm("Perubahan belum disimpan. Apakah Anda yakin ingin meninggalkan halaman ini?");
			if (answer) {
				this.updateEditing(false);
				next();
			} else {
				next(false);
			}
		} else {
			next();
		}
	},
	methods: {
		numberValidator(rule, value, callback) {
			if (value === null || value === undefined || value === "") {
				callback();
			} else if (isNaN(value) || Number(value) < 1) {
				callback(new Error("Nilai harus lebih besar dari 0"));
			} else {
				callback();
			}
		},
		handleFotoKTPChange(file) {
			if (file) {
				this.form.foto_ktp = file.raw;
				this.form.previewFotoKTP = URL.createObjectURL(file.raw);
			} else {
				this.form.foto_ktp = null;
				this.form.previewFotoKTP = "";
			}
		},
		async getListKabKota(parentId, awal = false) {
			try {
				const { data } = await this.$defaultApi.post("/list/kab-kota", {
					parent_id: parentId,
				});

				if (awal) this.listKabKotaAwal = data.kab_kota;
				this.listKabKota = data.kab_kota;
			} catch (error) {
				console.error(error);
			}
		},
		async getListKecamatan(parentId, awal = false) {
			try {
				const { data } = await this.$defaultApi.post("/list/kecamatan", {
					parent_id: parentId,
				});

				if (awal) this.listKecamatanAwal = data.kecamatan;
				this.listKecamatan = data.kecamatan;
			} catch (error) {
				console.error(error);
			}
		},
		async getListDesa(parentId, awal = false) {
			try {
				const { data } = await this.$defaultApi.post("/list/desa", {
					parent_id: parentId,
				});

				if (awal) this.listDesaAwal = data.desa;
				this.listDesa = data.desa;
			} catch (error) {
				console.error(error);
			}
		},
		async updateData() {
			this.loadingForm = true;

			const formData = new FormData();
			let changedFields = 0;
			for (const [key, value] of Object.entries(this.form)) {
				if ((value || typeof value === "number") && this.fieldAvailable[key]) {
					changedFields++;
					formData.append(key, value);
				}
			}
			try {
				if (changedFields === 0) {
					throw Error("Belum ada perubahan");
				}

				const valid = await this.$refs.formDataAyah.validate((res) => {
					return res;
				});
				if (!valid) {
					throw Error("Silakan masukkan isian sesuai dengan ketentuan");
				}

				formData.append("siswa_id", this.siswaId);
				const { data } = await this.$defaultApi.post("/detail/ayah/update", formData);
				this.edit = false;
				this.$notify.success({
					title: "Berhasil",
					message: data.message,
				});
			} catch (error) {
				if (error.response) {
					console.error(error.response.data.errMessage);
					return this.$notify.error({
						title: error.response.data.error || "Gagal",
						message: error.response.data.message,
					});
				}

				console.error(error);
				this.$notify.warning({
					title: "Perhatian",
					message: error.message,
				});
			} finally {
				setTimeout(() => {
					this.loadingForm = false;
				}, 500);
			}
		},
	},
};
</script>

<style scoped></style>
